

const leftNavColor = '#282e37';
const canvasColor = '#ffffff';
const textColor = '#282b34';

const lensTheme = {
    typography: {
        fontFamily: 'Arial',
        htmlFontSize: 14,
        button: {
            height: 48,
            textTransform: 'none',
        },
        h1: {
            fontSize: '1.875rem',
            lineHeight: '2.375rem',
            fontWeight: '400',
        },
        h2: {
            fontSize: 24,
            lineHeight: '2.125rem',
            fontWeight: '400',
        },
        h3: {
            fontSize: '1.375rem',
            fontWeight: '400',
            letterSpacing: 0.8,
            lineHeight: '1.75rem',
            textTransform: 'uppercase',
            color: textColor,
        },
        h4: {
            fontSize: '1.125rem',
            fontWeight: '400',
            lineHeight: '1.75rem',
        },
        h5: {
            fontSize: '1rem',
            fontWeight: '400',
            lineHeight: '1.5rem',
        },
        h6: {
            fontSize: '0.875rem',
            fontWeight: '400',
            lineHeight: '1.25rem',
        },
        subtitle1: {
            minWidth: 200,
            marginRight: 10,
            fontSize: 14,
            lineHeight: 3,
        },
    },
    palette: {
        background: {
            default: '#282E37!important',
        },
        text: {
            primary: '#1e1e1e',
            secondary: '#5d7599',
        },
        primary: {
            main: '#282e37',
            light: '#6f7377',
            dark: '#282e37',
        },
        secondary: {
            main: '#282e37',
            light: '#6f7377',
            dark: '#282e37',
        },
    },
    overrides: {
        MuiMenuItem: {
            root: {
                color: '#282b34',
                marginRight: 0,
            },
        },
        MuiListItem: {
            root: {
                '&$selected': {
                    backgroundColor: '#f3f3f3',
                    color: '#000',
                    '&:hover': {
                        backgroundColor: '#f3f3f3',
                    },
                },
            },
        },
        // MuiTouchRipple: {
        //   root: {
        //     color: 'var(--color--primary)',
        //   },
        // },
        MuiListItemIcon: {
            root: {
                color: '#999',
            },
        },
        MuiListItemText: {
            primary: {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                display: 'block',
            },
        },
        MuiDivider: {
            root: {
                marginTop: 36,
                marginBottom: 36,
            },
        },
        MuiCheckbox: {
            colorSecondary: {
                color: '#959595',
                '&$checked': {
                    color: '#282E37',
                },
            },
        },
        MuiRadio: {
            colorSecondary: {
                color: '#959595',
                '&$checked': {
                    color: '#282E37',
                },
            },
        },
        MuiTypography: {
            body1: {
                fontSize: 14,
            },
        },
        MuiFormControl: {
            root: {
                flexDirection: 'row',
            },
        },
        // raisedButton: {
        //   primaryColor: '#4ba7d7',
        //   secondaryColor: '#d74b4b',
        //   textTransform: 'none',
        //   height: 48
        // },

        MuiAppBar: {
            root: {
                zIndex: 1250,
            },
            colorPrimary: {
                backgroundColor: 'lightgray',
            },
        },
        MuiToolbar: {
            root: {
                height: 56,
                fontSize: 20,
            },
        },

        MuiButton: {
            root: {
                textTransform: 'none',
                fontSize: 16,
                fontWeight: 'bold',
                height: 42,
                borderRadius: 12,
                boxShadow: 'none',
                '&:focus': {
                    outlineWidth: 2,
                    outlineOffset: 1,
                    outlineStyle: 'solid',
                    outlineColor: '#0b4cce',
                },
            },
            contained: {
                boxShadow: 'none',
                backgroundColor: '#ffffff',
                border: 'solid 1px #282E37',
                color: '#282E37',
                '&:hover': {
                    backgroundColor: '#f3f3f3',
                    boxShadow: 'none',
                },
            },
            outlined: {
                boxShadow: 'none',
                borderColor: '#282E37',
                color: '#282E37',
                '&:hover': {
                    borderColor: '#282E37',
                    boxShadow: 'none',
                },
            },
            containedPrimary: {
                color: '#fff',
                backgroundColor: '#282E37',
                '&:hover': {
                    backgroundColor: '#282E37',
                },
            },
            containedSecondary: {
                color: '#282E37',
                backgroundColor: '#fff',
                border: 'solid 1px #282E37',
                '&:hover': {
                    backgroundColor: '#f3f3f3',
                },
            },
            outlinedSecondary: {
                color: '#282E37',
                backgroundColor: '#fff',
                borderColor: '#282E37',
                '&:hover': {
                    color: '#282E37',
                    borderColor: '#282E37',
                },
            },
            textSecondary: {
                color: '#282E37',
            },
        },
        MuiToggleButton: {
            root: {
                borderRadius: 12,
            },
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent',
                },
            },
        },
        // dialog: {
        //   bodyStyle: {
        //     backgroundColor: '#fff'
        //   },
        //   closeIcon: {
        //     height: 40,
        //     width: 40,
        //     color: '#C8C9CA'
        //   }
        // },
        MuiDialog: {
            paper: {
                backgroundColor: '#fff',
                borderRadius: 12,
            },
        },
        MuiDialogTitle: {
            root: {
                fontSize: 14,
                textTransform: 'uppercase',
                fontWeight: 'bold',
                position: 'relative',
            },
        },
        MuiDialogContent: {
            root: {
                paddingTop: 24,
                maxHeight: 'calc(100vh - 66px - 48px)',
            },
        },
        MuiTab: {
            root: {
                backgroundColor: canvasColor,
            },
            textColorInherit: {
                color: 'rgba(40, 43, 52, 0.6)',
                '&$selected': {
                    color: '#434343',
                },
            },
            textColorPrimary: {
                color: textColor,
                '&$selected': {
                    color: '#434343',
                },
            },
        },
        label: {
            textTransform: 'uppercase',
        },
        MuiTable: {
            root: {
                width: '100%',
                backgroundColor: '#ffffff',
            },
        },
        // tableRow: {
        //   stripeColor: canvasColor,
        //   hoverColor: '#C8E6F8',
        //   selectedColor: '#C8E6F8'
        // },

        // tableHeaderColumn: {
        //   textColor: '#83898F',
        //   spacing: 12
        // },
        MuiTableHead: {
            root: {
                color: '#000000',
                padding: 12,
                backgroundColor: '#f0f0f0',
            },
        },
        MuiTableRow: {
            root: {
                '&:hover td': {
                    backgroundColor: '#f3f3f3',
                },
                '&:last-child td': {
                    borderBottom: 'none',
                },
                '& td > .tr-actions': {
                    display: 'none',
                    position: 'absolute',
                    right: 4,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 1,
                },
                '&:hover td > .tr-actions': {
                    display: 'block',
                },
            },
        },
        // tableRowColumn: {
        //   spacing: 12
        // },
        MuiTableCell: {
            root: {
                fontSize: '15px',
                padding: 12,
                borderBottom: 'none',
            },
            head: {
                fontSize: '16px',
            },
            footer: {
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '15px',
            },
        },
        MuiTableSortLabel: {
            root: {
                color: '#fff',
                whiteSpace: 'nowrap',
                '&:hover': {
                    color: '#fff',
                },
            },
            active: {
                color: '#fff',
            },
        },

        // toolbar: {
        //   backgroundColor: darken(rawTheme.palette.accent2Color, 0.05),
        //   height: 56,
        //   titleFontSize: 20,
        //   iconColor: 'rgba(0, 0, 0, .40)',
        //   separatorColor: '#e9e9e9',
        //   menuHoverColor: 'rgba(0, 0, 0, .10)'
        // }

        leftNav: {
            color: leftNavColor,
        },
        TitleWindow: {
            root: {
                // backgroundColor: "#fff",
            },
            bodyStyle: {
                padding: '0 24px 0 24px',
            },
            contentStyle: {
                backgroundColor: '#fff',
            },
            header: {
                color: '#f36047',
                fontSize: '18px',
                textTransform: 'uppercase',
                // lineHeight: "40px",
                paddingTop: '36px',
                paddingLeft: '36px',
                iconButton: {
                    float: 'right',
                    marginTop: '-40px',
                    marginRight: '-25px',
                    display: 'none',
                },
            },
            content: {
                display: 'flex',
                flexDirection: 'column',
                height: '70vh',
            },
            Alert: {
                display: 'flex',
                flexDirection: 'column',
            },
        },
        AdvanceTitleWindow: {
            root: {
                backgroundColor: '#FFFFFF',
                padding: 0,
            },
            contentCont: {
                backgroundColor: '#FFFFFF',
            },
            header: {
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 15,
                paddingBottom: 15,
                backgroundColor: '#f3f3f3',
                height: 30,
                iconCont: {
                    paddingTop: 20,
                },
                icon: {
                    name: 'close',
                    fontSize: 40,
                    cursor: 'pointer',
                    color: 'white',
                },
            },
            headerLabelStyle: {
                fontSize: 18,
                fontWeight: 'bold',
                lineHeight: 1.88,
                color: '#ffffff',
            },
            content: {
                paddingLeft: '15px',
                fontSize: '15px',
                lineHeight: '27px',
                color: '#282b34',
            },
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#282E37',
            },
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                backgroundColor: '#ffffff',
                color: '#282E37',
            },
        },
    },
    props: {
        MuiButton: {
            disableElevation: true,
            disableRipple: true,
        },
        MuiMenuItem: {
            disableRipple: true,
        },
        MuiListItem: {
            disableRipple: true,
        },
        MuiSelect: {
            MenuProps: {
                MenuListProps: {
                    disablePadding: true,
                },
            },
        },
        MuiToggleButton: {
            disableRipple: true,
        },
        MuiTextField: {
            classes: {
                root: "lens-text-field-warper",
            },
            InputProps: {
                classes: {
                    root: "lens-text-field-root",
                }
            }
        },
    },
};

export default lensTheme;
